import { useLocation, Link } from 'react-router-dom';
import { Bot, Calendar, Command, KanbanSquare, MessageSquare } from 'lucide-react';
import clsx from 'clsx';

const tabs = [
  { label: 'Command',  href: '/app',      icon: Command,       exact: true },
  { label: 'Pipeline', href: '/pipeline', icon: KanbanSquare },
  { label: 'Messages', href: '/inbox',    icon: MessageSquare },
  { label: 'Calendar', href: '/calendar', icon: Calendar },
];

export interface MobileBottomNavProps {
  onOpenCommand?: () => void;
}

export function MobileBottomNav({ onOpenCommand }: MobileBottomNavProps) {
  const location = useLocation();

  function isActive(tab: (typeof tabs)[number]) {
    if ('exact' in tab && tab.exact) return location.pathname === tab.href;
    return location.pathname.startsWith(tab.href);
  }

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 font-hhp-sans lg:hidden">
      {/* Nav bar */}
      <div className="relative border-t border-white/10 bg-hhp-navy px-2">
        <div className="flex items-center justify-around">
          {tabs.map((tab) => {
            const active = isActive(tab);
            return (
              <Link
                key={tab.href}
                to={tab.href}
                className={clsx(
                  'relative flex flex-col items-center gap-1 px-4 py-2 text-[10px] font-semibold uppercase tracking-wide transition-all',
                  active ? 'text-hhp-gold' : 'text-white/50',
                )}
              >
                <tab.icon
                  className={clsx(
                    'h-5 w-5 transition-all',
                    active ? 'scale-110 text-hhp-gold' : 'text-white/40',
                  )}
                />
                <span>{tab.label}</span>
                {active && (
                  <span className="absolute bottom-0 h-0.5 w-8 rounded-full bg-hhp-gold" />
                )}
              </Link>
            );
          })}
        </div>
      </div>
      {onOpenCommand && (
        <button
          type="button"
          onClick={onOpenCommand}
          className="absolute -top-4 left-1/2 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full bg-hhp-gold text-hhp-navy shadow-lg transition hover:bg-hhp-gold/90"
          aria-label="Open assistant activity"
        >
          <Bot className="h-4 w-4" />
        </button>
      )}
    </nav>
  );
}
